import React from 'react';

import moment from 'moment';

import {
  GetFluxNextExecutionTimeResponseDtoFluxTypeEnum,
  RpsiFluxDto,
} from 'lib_api/lib/api/gen';

import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { FluxDisplayName } from 'enums/flux/FluxDisplayName';
import useNextExecutionTime from 'hooks/flux/useNextExecutionTime';
import { useDashboardSearchWithSort } from 'hooks/search/useDashboardSearchWithSort';
import { DATE_FORMAT } from 'utils/formats';

import DashboardFlux from '../DashboardFlux';
import { statusIconMapping } from '../utils';

import ErrorCell from './Details/ErrorCell/ErrorCell';
import { FluxRpsiSortOptions } from './types';
import { useSearchFluxRpsi } from './utils';

function DashboardImportsRpsi(): React.ReactElement {
  const searchFluxRpsi = useDashboardSearchWithSort(
    useSearchFluxRpsi,
    {},
    {
      DATE_APPEL: false,
    },
    'paginationFluxRpsi',
  );
  const fluxType = GetFluxNextExecutionTimeResponseDtoFluxTypeEnum.RPSI_BATCH;
  const nextExecutionTime = useNextExecutionTime(fluxType);

  function buildDetailsContent(data: RpsiFluxDto): React.ReactElement {
    return <ErrorCell flux={data} />;
  }

  function computeBadge(flux: RpsiFluxDto): React.ReactNode {
    if (flux.errors.length) {
      return statusIconMapping.ERROR;
    } else {
      return statusIconMapping.SUCCESS;
    }
  }

  function buildColumns(): ColumnProps<RpsiFluxDto, FluxRpsiSortOptions>[] {
    return [
      {
        title: '',
        buildCellContent: data => computeBadge(data),
      },
      {
        title: 'Appel',
        buildCellContent: data => moment(data.dateAppel).format(DATE_FORMAT),
        sortedField: FluxRpsiSortOptions.DATE_APPEL,
      },
      {
        title: 'Max maj date',
        buildCellContent: data =>
          data.maxMajDate ? moment(data.maxMajDate).format(DATE_FORMAT) : '',
      },
      {
        title: 'Fichier',
        buildCellContent: data => data.filename,
      },
      {
        title: "Type d'erreur",
        buildCellContent: data => buildDetailsContent(data),
      },
    ];
  }

  return (
    <DashboardFlux
      useSearchFlux={searchFluxRpsi}
      buildColumns={buildColumns}
      title={FluxDisplayName.RPSI}
      dateProchaineExecution={nextExecutionTime}
    />
  );
}

export default DashboardImportsRpsi;
